export default __webpack_public_path__ + "static/media/pipesProcess.c1b6f030.png";